import {Product} from '../models/products/product.model';
import {ProductUpdate} from '../models/products/product.update';
import {ProductImage} from '../models/products/productImage.model';
import {JobProduct} from '../models/products/jobProduct.model';

export namespace Products {
  export class GetProducts {
    static readonly type = '[Products api] GetProducts';

    constructor(public force: boolean = false) {
    }
  }

  export class GetProduct {
    static readonly type = '[Products api] GetProduct';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateProduct {
    static readonly type = '[Products api] CreateProduct';

    constructor(public product: Product, public images: ProductImage[]) {
    }
  }

  export class UpdateProduct {
    static readonly type = '[Products api] Update Product';

    constructor(public product: ProductUpdate, public images: ProductImage[]) {
    }
  }

  export class DeleteProduct {
    static readonly type = '[Products api] Delete Product';

    constructor(public product: Product) {
    }
  }

  export class GetJobProducts {
    static readonly type = '[Products api] GetJobProducts';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateJobProductsLocal {
    static readonly type = '[Products local] Update Job Products';

    constructor(public products: Array<JobProduct>) {
    }
  }

  export class UpdateJobProducts {
    static readonly type = '[Products api] Update Job Products';

    constructor(public jobId: string, public products: Array<JobProduct>) {
    }
  }
}
